import React from "react";
import CustomToolTip from "./custom-tooltip";
import TooltipReact from "./tooltip";

export const ToolTip = ({
  id = 0,
  toolTipText = null,
  content = null,
  align = "right",
  customClassName = "custom-tooltip",
  ToolTipIcon = true,
  tooltipStyle = {},
  defaultTag = "span",
  tooltipClass = "card-tooltip",
}) => {
  return (
    <TooltipReact
      id={id}
      content={content}
      align={align}
      customClassName={customClassName}
      tooltipClass={tooltipClass}
      tooltipStyle={tooltipStyle}
      toolTip={
        <CustomToolTip
          textOne={toolTipText}
          ToolTipIcon={ToolTipIcon}
          defaultTag={defaultTag}
        />
      }
    />
  );
};

export { CustomToolTip, TooltipReact };
